import Navigation from './Nav';
import Sidebar from './Sidebar';

const Header = () => (
  <>
    <Navigation />
    <Sidebar />
  </>
);

export default Header;
